/**
 * Catálogo canónico de métricas para el dueño (glosario).
 * Las definiciones viven en i18n `metrics.glossary.{id}.*` — no reescribir copy suelto.
 */

export const METRIC_DEFINITION_IDS = [
  'revenue',
  'patients',
  'appointments',
  'absenteeism',
  'pvp',
  'net',
  'expense',
  'topPaymentMethod',
  'conversion',
  'noReturn',
  'newPatients',
] as const;

export type MetricDefinitionId = (typeof METRIC_DEFINITION_IDS)[number];

export type MetricGlossaryField = 'name' | 'definition' | 'notes';

const ID_SET = new Set<string>(METRIC_DEFINITION_IDS);

export function isMetricDefinitionId(value: string): value is MetricDefinitionId {
  return ID_SET.has(value);
}

export function metricGlossaryKey(id: MetricDefinitionId, field: MetricGlossaryField): string {
  return `metrics.glossary.${id}.${field}`;
}
